<template>
    <div id="show-traceroute" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header-dialog-painting">
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true"><i class="fa-regular fa-xmark"></i></span>
                        <span class="sr-only">{{ t_close }}</span>
                    </button>
                    <div class="modal-title">{{ t_title }} "{{ ip }}"</div>
                </div>
                <div class="modal-body" v-html="response_formatted"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                t_close: Lang.langGet("Close"),
                t_title: Lang.langGet("Traceroute for host"),
                ip: null,
                response: null
            }
        },
        computed: {
            response_formatted: function() {
                if (this.response !== null) {
                    return this.response.replace(new RegExp('\\n', 'g'), "<br>");
                } else {
                    return '';
                }
            }
        },
        mounted() {
            EaseEventBus.listen('showTraceroute', (data) => {
                this.response = data.response;
                this.ip = data.ip;
                EaseEventBus.fire('showModal', 'show-traceroute');
            });
        }
    }
</script>
